(() => {
  const money = (cents, format) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }

    const amount = (Number(cents || 0) / 100).toFixed(2);

    return (format || '${{amount}}').replace(
      /\{\{\s*amount(?:_with_comma_separator|_no_decimals|_no_decimals_with_comma_separator)?\s*\}\}/,
      amount
    );
  };

  const parseJSON = node => {
    try {
      return JSON.parse(node?.textContent || '[]');
    } catch (_) {
      return [];
    }
  };

  const sectionInner = (html, selector = '.shopify-section') => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);

    return el ? el.innerHTML : '';
  };

  const renderCartSections = async () => {
    try {
      const rootPath = window.Shopify?.routes?.root || '/';

      const cartResponse = await fetch(`${rootPath}cart.js`, {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      });

      const cart = await cartResponse.json();

      const pageResponse = await fetch(
        `${window.location.pathname}?cart_refresh=${Date.now()}`,
        {
          method: 'GET',
          cache: 'no-store'
        }
      );

      const html = await pageResponse.text();

      const doc = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      const newDrawer = doc.getElementById('Cart-Drawer');
      const currentDrawer = document.getElementById('Cart-Drawer');

      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }

      const countSelectors = [
        '.thb-item-count',
        '.cart-count-bubble',
        '.cart-count',
        '[data-cart-count]'
      ];

      countSelectors.forEach(selector => {
        const newEl = doc.querySelector(selector);
        const currentEl = document.querySelector(selector);

        if (newEl && currentEl) {
          currentEl.innerHTML = newEl.innerHTML;
        }
      });

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart
          }
        })
      );

    } catch (error) {
      console.error(
        '[Carbon-X] Cart refresh failed:',
        error
      );
    }
  };



  const shopifyCartPost = (url, payload) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.open('POST', url, true);

    xhr.setRequestHeader(
      'Content-Type',
      'application/json'
    );

    xhr.setRequestHeader(
      'Accept',
      'application/json'
    );

    xhr.setRequestHeader(
      'X-Requested-With',
      'XMLHttpRequest'
    );

    xhr.onload = () => {
      let data;

      try {
        data = JSON.parse(xhr.responseText);
      } catch (error) {
        reject(
          new Error(
            'Invalid Shopify cart response.'
          )
        );
        return;
      }

      if (
        xhr.status >= 200 &&
        xhr.status < 300
      ) {
        resolve(data);
      } else {
        reject(
          new Error(
            data?.description ||
            data?.message ||
            `Cart request failed: ${xhr.status}`
          )
        );
      }
    };

    xhr.onerror = () => {
      reject(
        new Error(
          'Unable to connect to Shopify cart.'
        )
      );
    };

    xhr.send(
      JSON.stringify(payload)
    );
  });
};

  const openCartDrawer = () => {
    const drawer = document.getElementById('Cart-Drawer');

    if (!drawer) return;

    document.body.classList.add(
      'open-cc',
      'open-cart'
    );

    drawer.classList.add('active');

    try {
      document.dispatchEvent(
        new CustomEvent('cart-drawer:open')
      );
    } catch (_) {}
  };

  const init = root => {
    if (
      !root ||
      root.dataset.wgCarbonReady === 'true'
    ) {
      return;
    }

    root.dataset.wgCarbonReady = 'true';

    const variants = parseJSON(
      root.querySelector(
        '[data-wg-carbon-variants]'
      )
    );

    const sellingPlanData = parseJSON(
      root.querySelector(
        '[data-wg-carbon-selling-plans]'
      )
    );

    const moneyFormat =
      root.dataset.moneyFormat ||
      '${{amount}}';

    const buyControls = root.querySelector(
      '[data-wg-carbon-product-form]'
    );

    const variantInput = root.querySelector(
      '[data-wg-carbon-variant-id]'
    );

    if (!buyControls) return;

    const addButton = root.querySelector(
      '[data-wg-carbon-add]'
    );

    const addText = root.querySelector(
      '[data-wg-carbon-button-text]'
    );

    const soldBadge = root.querySelector(
      '[data-wg-carbon-sold-badge]'
    );

    const onePrice = root.querySelector(
      '[data-wg-carbon-onetime-price]'
    );

    const subPrice = root.querySelector(
      '[data-wg-carbon-sub-price]'
    );

    const subCompare = root.querySelector(
      '[data-wg-carbon-sub-compare]'
    );

    const subscribeCard = root.querySelector(
      '[data-wg-carbon-mode="subscribe"]'
    );

    const frequencyWrap = root.querySelector(
      '[data-wg-carbon-frequency-wrap]'
    );

    const frequencyGrid = root.querySelector(
      '[data-wg-carbon-frequency-grid]'
    );

    const modeInputs = [
      ...root.querySelectorAll(
        '[data-wg-carbon-mode-input]'
      )
    ];

    let mode = 'onetime';
    let selectedPlanId = null;

    const currentVariant = () => {
      const selected = variants.find(
        v =>
          String(v.id) ===
          String(variantInput?.value)
      );

      const variant =
        (selected?.available
          ? selected
          : null) ||
        variants.find(v => v.available) ||
        selected ||
        variants[0] ||
        null;

      if (
        variant &&
        variantInput &&
        String(variantInput.value) !==
          String(variant.id)
      ) {
        variantInput.value = String(
          variant.id
        );
      }

      return variant;
    };

    const currentAllocations = () => {
      const v = currentVariant();

      const row = sellingPlanData.find(
        item =>
          String(item.variant_id) ===
          String(v?.id)
      );

      return Array.isArray(
        row?.allocations
      )
        ? row.allocations
        : [];
    };

    const planText = plan =>
      `${plan?.name || ''} ${JSON.stringify(
        plan?.options || []
      )}`.toLowerCase();

    const planTitle = (
      plan,
      index
    ) => {
      const t = planText(plan);

      if (
        /(^|\D)30(\D|$)|1\s*month|monthly/.test(
          t
        )
      ) {
        return (
          root.dataset.freqTitle30 ||
          'Every 30 Days'
        );
      }

      if (
        /(^|\D)60(\D|$)|2\s*month/.test(
          t
        )
      ) {
        return (
          root.dataset.freqTitle60 ||
          'Every 60 Days'
        );
      }

      if (
        /(^|\D)90(\D|$)|3\s*month|quarter/.test(
          t
        )
      ) {
        return (
          root.dataset.freqTitle90 ||
          'Every 90 Days'
        );
      }

      return (
        plan?.name ||
        `Delivery option ${index + 1}`
      );
    };

    const planSubtitle = (
      plan,
      index
    ) => {
      const t = planText(plan);

      if (
        /(^|\D)30(\D|$)|1\s*month|monthly/.test(
          t
        )
      ) {
        return (
          root.dataset.freqText30 ||
          'Best for daily smokers.'
        );
      }

      if (
        /(^|\D)60(\D|$)|2\s*month/.test(
          t
        )
      ) {
        return (
          root.dataset.freqText60 ||
          'Best for regular weekly use.'
        );
      }

      if (
        /(^|\D)90(\D|$)|3\s*month|quarter/.test(
          t
        )
      ) {
        return (
          root.dataset.freqText90 ||
          'Best for occasional smokers.'
        );
      }

      return (
        root.dataset.freqTextOther ||
        'Automatic recurring delivery.'
      );
    };

    const getPlanId = p =>
      p?.selling_plan_id ||
      p?.selling_plan?.id ||
      p?.id;

    const selectedPlan = () =>
      currentAllocations().find(
        p =>
          String(getPlanId(p)) ===
          String(selectedPlanId)
      ) ||
      currentAllocations()[0] ||
      null;

    const renderFrequencies = () => {
      const allocations =
        currentAllocations();

      if (!allocations.length) {
        selectedPlanId = null;

        if (frequencyGrid) {
          frequencyGrid.innerHTML = '';
        }

        subscribeCard?.classList.add(
          'is-disabled'
        );

        subscribeCard?.setAttribute(
          'aria-disabled',
          'true'
        );

        if (mode === 'subscribe') {
          mode = 'onetime';
        }

        return;
      }

      subscribeCard?.classList.remove(
        'is-disabled'
      );

      subscribeCard?.setAttribute(
        'aria-disabled',
        'false'
      );

      if (
        !allocations.some(
          p =>
            String(getPlanId(p)) ===
            String(selectedPlanId)
        )
      ) {
        selectedPlanId = getPlanId(
          allocations[0]
        );
      }

      if (frequencyGrid) {
        frequencyGrid.innerHTML = '';

        allocations.forEach(
          (plan, index) => {
            const planId =
              getPlanId(plan);

            const button =
              document.createElement(
                'button'
              );

            button.type = 'button';

            button.className =
              'wg-frequency';

            button.dataset.wgCarbonPlan =
              String(planId);

            button.innerHTML = `
              <div style="font-size:14.5px;font-weight:700;color:#fff;margin-bottom:4px;">
                ${planTitle(
                  plan,
                  index
                )}
              </div>

              <div style="font-size:11.5px;line-height:1.35;color:rgba(255,255,255,.55);">
                ${planSubtitle(
                  plan,
                  index
                )}
              </div>
            `;

            button.addEventListener(
              'click',
              () => {
                selectedPlanId =
                  planId;

                syncPurchase();
              }
            );

            frequencyGrid.appendChild(
              button
            );
          }
        );
      }
    };

    const syncPurchase = () => {
      const variant =
        currentVariant();

      const plan =
        selectedPlan();

      root
        .querySelectorAll(
          '[data-wg-carbon-mode]'
        )
        .forEach(card =>
          card.classList.toggle(
            'is-active',
            card.dataset
              .wgCarbonMode ===
              mode
          )
        );

      modeInputs.forEach(
        input => {
          input.checked =
            input.value === mode;
        }
      );

      if (frequencyWrap) {
        frequencyWrap.hidden =
          mode !== 'subscribe';
      }

      root
        .querySelectorAll(
          '[data-wg-carbon-plan]'
        )
        .forEach(btn =>
          btn.classList.toggle(
            'is-active',
            String(
              btn.dataset
                .wgCarbonPlan
            ) ===
              String(
                selectedPlanId
              )
          )
        );

      if (
        onePrice &&
        variant
      ) {
        onePrice.textContent = money(
          variant.price,
          moneyFormat
        );
      }

      if (subPrice) {
        subPrice.textContent = plan
          ? money(
              plan.price,
              moneyFormat
            )
          : root.dataset
              .subscriptionUnavailableText ||
            'Unavailable';
      }

      if (subCompare) {
        subCompare.hidden = !plan;

        subCompare.textContent =
          variant
            ? money(
                variant.price,
                moneyFormat
              )
            : '';
      }

      const variantAvailable =
        Boolean(
          variant?.id &&
            variant.available
        );

      if (soldBadge) {
        soldBadge.hidden =
          variantAvailable;
      }

      if (addText) {
        const label =
          mode === 'subscribe'
            ? root.dataset
                .subscribeButtonText ||
              'SUBSCRIBE & SAVE'
            : root.dataset
                .onetimeButtonText ||
              'ADD TO CART';

        const price =
          mode === 'subscribe' &&
          plan
            ? plan.price
            : variant?.price;

        addText.textContent =
          variantAvailable
            ? price != null
              ? `${label} ${money(
                  price,
                  moneyFormat
                )}`
              : label
            : root.dataset
                .soldOutText ||
              'SOLD OUT';
      }

      const canPurchase =
        variantAvailable &&
        (
          mode !== 'subscribe' ||
          Boolean(
            getPlanId(plan)
          )
        );

      if (addButton) {
        addButton.disabled =
          !canPurchase;

        addButton.setAttribute(
          'aria-disabled',
          String(
            !canPurchase
          )
        );
      }
    };

    modeInputs.forEach(
      input =>
        input.addEventListener(
          'change',
          () => {
            if (
              input.value ===
                'subscribe' &&
              !currentAllocations()
                .length
            ) {
              return;
            }

            mode = input.value;

            syncPurchase();
          }
        )
    );

    let cleanupQueued = false;

    const removeInjectedBuyboxUI =
      () => {
        cleanupQueued = false;

        root
          .querySelectorAll(
            [
              '.appstle_sub_widget',
              '.appstle_subscription_widget',
              '.appstle_subscription_wrapper',
              '[id^="appstle_subscription_widget"]',
              '[class*="appstle_sub_widget"]',
              '[data-appstle-subscription-widget]',
              '#ultimateTrustBadgeswidgetDiv',
              '[id*="ultimateTrustBadges"]',
              '[class*="ultimateTrustBadges"]',
              '.shopify-payment-button',
              '.additional-checkout-buttons',
              '.payment_icons_wrap',
              '.payment-icons-wrap',
              '[class*="secure-checkout"]',
              '[class*="secure_checkout"]',
              '[data-testid*="secure-checkout"]'
            ].join(',')
          )
          .forEach(el =>
            el.remove()
          );

        buyControls
          ?.querySelectorAll(
            'p,span,div,label'
          )
          .forEach(el => {
            if (
              el.closest(
                '.wg-qty,.wg-button,[data-wg-carbon-error]'
              )
            ) {
              return;
            }

            const text =
              (
                el.textContent ||
                ''
              )
                .trim()
                .replace(
                  /\s+/g,
                  ' '
                );

            if (
              /^(purchase options|subscription details?|learn about subscriptions powered by appstle)$/i.test(
                text
              )
            ) {
              el.remove();
            }
          });

        root
          .querySelectorAll(
            'p,span,div'
          )
          .forEach(el => {
            if (
              el.children.length >
              4
            ) {
              return;
            }

            const text =
              (
                el.textContent ||
                ''
              )
                .trim()
                .replace(
                  /\s+/g,
                  ' '
                );

            if (
              /^secure checkout with\b/i.test(
                text
              )
            ) {
              const parent =
                el.parentElement;

              if (
                parent &&
                (
                  parent.textContent ||
                  ''
                )
                  .trim()
                  .replace(
                    /\s+/g,
                    ' '
                  ) === text
              ) {
                parent.remove();
              } else {
                el.remove();
              }
            }
          });
      };

    const queueCleanup = () => {
      if (cleanupQueued) {
        return;
      }

      cleanupQueued = true;

      requestAnimationFrame(
        removeInjectedBuyboxUI
      );
    };

    removeInjectedBuyboxUI();

    const observer =
      new MutationObserver(
        queueCleanup
      );

    observer.observe(
      root,
      {
        childList: true,
        subtree: true
      }
    );

    const slides = [
      ...root.querySelectorAll(
        '[data-wg-carbon-media]'
      )
    ];

    const thumbs = [
      ...root.querySelectorAll(
        '[data-wg-carbon-thumb]'
      )
    ];

    root.dataset.galleryIndex =
      String(
        Math.max(
          0,
          slides.findIndex(
            s =>
              s.classList.contains(
                'is-active'
              )
          )
        )
      );

    const showAt = index => {
      if (!slides.length) {
        return;
      }

      const i =
        (
          index +
          slides.length
        ) %
        slides.length;

      slides.forEach(
        (s, n) =>
          s.classList.toggle(
            'is-active',
            n === i
          )
      );

      thumbs.forEach(
        (t, n) =>
          t.classList.toggle(
            'is-active',
            n === i
          )
      );

      root.dataset.galleryIndex =
        String(i);
    };

    thumbs.forEach(
      (t, i) =>
        t.addEventListener(
          'click',
          () => showAt(i)
        )
    );

    root
      .querySelector(
        '[data-wg-carbon-gallery-prev]'
      )
      ?.addEventListener(
        'click',
        () =>
          showAt(
            Number(
              root.dataset
                .galleryIndex ||
                0
            ) - 1
          )
      );

    root
      .querySelector(
        '[data-wg-carbon-gallery-next]'
      )
      ?.addEventListener(
        'click',
        () =>
          showAt(
            Number(
              root.dataset
                .galleryIndex ||
                0
            ) + 1
          )
      );

    const qtyInput =
      root.querySelector(
        '[data-wg-carbon-qty]'
      );

    const qtyDisplay =
      root.querySelector(
        '[data-wg-carbon-qty-display]'
      );

    const setQty = value => {
      if (!qtyInput) {
        return;
      }

      const min = Number(
        qtyInput.min || 1
      );

      const max =
        qtyInput.max
          ? Number(
              qtyInput.max
            )
          : Infinity;

      const safe =
        Math.min(
          max,
          Math.max(
            min,
            Number(
              value || min
            )
          )
        );

      qtyInput.value =
        String(safe);

      if (qtyDisplay) {
        qtyDisplay.textContent =
          String(safe);
      }
    };

    root
      .querySelector(
        '[data-wg-carbon-minus]'
      )
      ?.addEventListener(
        'click',
        () =>
          setQty(
            Number(
              qtyInput?.value ||
                1
            ) - 1
          )
      );

    root
      .querySelector(
        '[data-wg-carbon-plus]'
      )
      ?.addEventListener(
        'click',
        () =>
          setQty(
            Number(
              qtyInput?.value ||
                1
            ) + 1
          )
      );

    setQty(
      qtyInput?.value || 1
    );

    const setLoading =
      state => {
        root.classList.toggle(
          'wg-loading',
          state
        );

        const variant =
          currentVariant();

        const plan =
          selectedPlan();

        const canPurchase =
          Boolean(
            variant?.id &&
              variant.available
          ) &&
          (
            mode !==
              'subscribe' ||
            Boolean(
              getPlanId(plan)
            )
          );

        if (addButton) {
          addButton.disabled =
            Boolean(state) ||
            !canPurchase;

          addButton.setAttribute(
            'aria-disabled',
            String(
              Boolean(state) ||
              !canPurchase
            )
          );
        }
      };

    const addItem = async (
      e,
      checkout = false
    ) => {
      if (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }

      const variant =
        currentVariant();

      const err =
        root.querySelector(
          '[data-wg-carbon-error]'
        );

      if (
        !variant?.id ||
        !variant.available
      ) {
        if (err) {
          err.textContent =
            root.dataset
              .soldOutText ||
            'SOLD OUT';

          err.hidden = false;
        }

        return;
      }

      const checkedModeInput =
        root.querySelector(
          '[data-wg-carbon-mode-input]:checked'
        );

      const activeMode =
        checkedModeInput
          ? checkedModeInput
              .value
          : mode;

      const quantity =
        Math.max(
          1,
          Number(
            qtyInput?.value ||
              1
          )
        );

      const item = {
        id: Number(
          variant.id
        ),
        quantity
      };

      if (
        activeMode ===
        'subscribe'
      ) {
        const plan =
          selectedPlan();

        const planId =
          getPlanId(plan);

        if (!planId) {
          if (err) {
            err.textContent =
              'Please select a subscription frequency.';

            err.hidden =
              false;
          }

          return;
        }

        item.selling_plan =
          Number(planId);
      }

      setLoading(true);

      try {
        if (err) {
          err.hidden = true;
          err.textContent =
            '';
        }

        const payload = {
          items: [item]
        };

        console.log(
          '[Carbon-X] Cart payload:',
          payload
        );

        const result = await shopifyCartPost(
  `${window.Shopify?.routes?.root || '/'}cart/add.js`,
  payload
);

console.log(
  '[Carbon-X] Shopify RAW XHR add response:',
  result
);

        if (
          activeMode ===
          'subscribe'
        ) {
          const addedItem =
            Array.isArray(
              result.items
            )
              ? result.items[0]
              : result;

          if (
            !addedItem
              ?.selling_plan_allocation
          ) {
            console.error(
              '[Carbon-X] Shopify added the item without a selling plan allocation.',
              addedItem
            );
          }
        }

        await renderCartSections();

        if (checkout) {
          window.location.href =
            `${window.Shopify?.routes?.root || '/'}checkout`;
        } else {
          openCartDrawer();
        }

      } catch (error) {
        console.error(
          '[Carbon-X] Add to cart failed:',
          error
        );

        if (err) {
          err.textContent =
            error.message ||
            'Unable to add this item to the cart.';

          err.hidden =
            false;
        }

      } finally {
        setLoading(false);
      }
    };

    addButton?.addEventListener(
      'click',
      e => {
        addItem(
          e,
          false
        );
      }
    );

    root
      .querySelectorAll(
        '[data-wg-carbon-scroll-buybox]'
      )
      .forEach(
        btn =>
          btn.addEventListener(
            'click',
            e => {
              e.preventDefault();

              const targetMode =
                btn.dataset
                  .wgCarbonScrollBuybox;

              if (
                targetMode ===
                  'subscribe' &&
                currentAllocations()
                  .length
              ) {
                mode =
                  'subscribe';
              } else {
                mode =
                  'onetime';
              }

              syncPurchase();

              root
                .querySelector(
                  '[data-wg-carbon-buybox]'
                )
                ?.scrollIntoView(
                  {
                    behavior:
                      'smooth',
                    block:
                      'start'
                  }
                );
            }
          )
      );

    root
      .querySelectorAll(
        'video[data-src]'
      )
      .forEach(video => {
        if (
          !video.src &&
          video.dataset.src
        ) {
          video.src =
            video.dataset.src;
        }
      });

    renderFrequencies();
    syncPurchase();

    root
      .querySelectorAll(
        '[data-wg-carbon-size-option]'
      )
      .forEach(pill => {
        pill.addEventListener(
          'click',
          () => {
            const id =
              pill.getAttribute(
                'data-variant-id'
              );

            if (
              !id ||
              !variantInput
            ) {
              return;
            }

            variantInput.value =
              id;

            root
              .querySelectorAll(
                '[data-wg-carbon-size-option]'
              )
              .forEach(p => {
                const on =
                  p === pill;

                p.classList.toggle(
                  'is-active',
                  on
                );

                p.setAttribute(
                  'aria-pressed',
                  on
                    ? 'true'
                    : 'false'
                );
              });

            selectedPlanId =
              null;

            renderFrequencies();
            syncPurchase();
          }
        );
      });

    if (
      window.lucide
        ?.createIcons
    ) {
      window.lucide.createIcons(
        {
          attrs: {
            'stroke-width':
              1.8
          }
        }
      );
    }
  };

  const initAll = (
    scope = document
  ) => {
    if (
      scope.matches?.(
        '[data-wg-carbon-section]'
      )
    ) {
      init(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-wg-carbon-section]'
      )
      .forEach(init);
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAll()
    );
  } else {
    initAll();
  }

  document.addEventListener(
    'shopify:section:load',
    e => initAll(e.target)
  );
})();